import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Multiselect from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import {
  getAllModulelist,
  getAllRolelist,
  getNewUser,
  getUserById,
  getEditUser,
} from "../../../service/AddUser/AddUserService";
import { getAllDepartmentDetailslist } from "../../../service/Department/DepartmentService";
import Select from "react-select";
// import 'react-select/dist/react-select.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import SpinnerComponent from "../../components/SpinnerComponent";
import instance from "../../../WebApi/WebApi";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import {
  getInvoiceSupplierList,
  getInvoiceSupplierListCommon,
} from "../../../service/Product/ProductService";
import { useTranslation } from "react-i18next";

const EditUser = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showpassword, setShowPassword] = useState("");
  const [password, setPassword] = useState("");
  const [showconfirmpassword, setShowConfirmPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");

  const { logo } = props;
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("");
  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [module, setModule] = useState([]);
  const [moduleById, setModuleById] = useState("");
  const [departmentList, setAllDepartmentList] = useState([]);
  const [search, setSearch] = useState("");
  const [department, setDepartment] = useState([]);
  const [overView, setOverView] = useState("");
  const [role, setRole] = useState("");
  const [roleList, setAllRoleList] = useState([]);
  const [selectedValues, setSelectedValues] = useState("");
  const [accountKey, setAccountKey] = useState("");
  const [selectedValuesDepartment, setSelectedValuesDepartment] = useState([]);

  const [selectedFinalValues, setSelectedFinalValues] = useState([]);
  const [myArrayBusiness, setMyArrayBusiness] = useState([]);

  const [myArray, setMyArray] = useState([]);
  const [myArrayDepartment, setMyArrayDepartment] = useState([]);
  const [myArrayModule, setMyArrayModule] = useState([]);
  const [businesUnitData, setAllBusinessUnit] = useState([]);
  const [business, setBusiness] = useState([]);
  const location = useLocation();
  const industryById = new URLSearchParams(location.search);
  const [allData, setAllData] = useState({
    name: "",
    shortName: "",
    overview: "",
  });
  const [allDataModule, setAllDataModule] = useState([]);
  const [allDataDepartment, setAllDataDepartment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moduleIds, setModuleIds] = useState([]);

  const [moduleDropDownData, setModuleDropDownData] = useState([]);

  const deptfinal = allDataDepartment?.map((d) => d?.Department?.id);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // console.log(deptfinal,"selectedFinalValues")

  const modulefinal = allDataModule?.map((d) => d?.Module?.id);
  // console.log(deptfinal, myArrayDepartment, "selectedFinalValues");

  useEffect(() => {
    // getallIndustryList()
    setIsLoading(true);
    getInvoiceSupplierDataList();
    getUserById(industryById.get(`id`)).then(function (result) {
      const response = result.data;
      // console.log(response, "response")
      // setIndustryId(response?.data?.businessUnit);
      setAllData({
        ...response?.data?.employee,
        name: response?.data?.employee?.name
          ? response?.data?.employee?.name
          : `${response?.data?.employee?.firstName} ${response?.data?.employee?.lastName}`,
      });
      setAccountKey(response?.data?.employee?.accountKey);
      // console.log(response?.data?.employee?.accountKey, "jhgfdsa")
      setAllDataModule(response?.data?.employee?.SelectedUserModules);
      setAllDataDepartment(response?.data?.employee?.SelectedUserDepartments);
      // setModuleById(
      //   response?.data?.employee?.SelectedUserModules.map((item) => {
      //     return { value: item?.Module?.id, label: item?.Module?.type };
      //   })
      // );
      setSelectedValues(response?.data?.employee?.UserJobRoleId);

      const selectedModule = response?.data?.employee?.SelectedUserModules?.map(
        (d) => ({
          value: d?.Module?.id,
          label: d?.Module?.type,
        })
      );
      setModuleById(selectedModule);
      if (response?.data?.employee?.selectedBusinessData.length !== 0) {
        setBusiness(
          response?.data?.employee?.selectedBusinessData?.map((item) => {
            return { value: item?.id, label: item?.name };
          })
        );
      } else {
        setBusiness([]);
      }
      // console.log("busines---->", business);
      const businessIds = response?.data?.employee?.selectedBusinessData?.map(
        (item) => item?.id
      );
      getDepartmentList(businessIds);

      setDepartment(
        response?.data?.employee?.SelectedUserDepartments.map((item) => {
          return {
            value: item?.Department?.id,
            label: item?.Department?.name,
            businessUnitId: item?.businessUnitId,
          };
        })
      );
      setSelectedOptions(
        response?.data?.employee?.SelectedUserSuppliers.map((item) => {
          return {
            value: item?.Supplier?.id,
            label: item?.Supplier?.name,
          };
        })
      );

      getModule(response?.data?.employee?.UserJobRoleId);
      setIsLoading(false);
    });
  }, []);

  async function getInvoiceSupplierDataList() {
    setIsLoading(true);
    getInvoiceSupplierListCommon().then(function (result) {
      const response = result?.data;
      // console.log("resposne5414654", response);
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);

      setIsLoading(false);
    });
  }

  const moduleDataFetch = async (id) => {
    const response = await instance.get(
      `/customer/employee/list-module-by-role/${id}`
    );
    setModuleDropDownData(response?.data?.data?.moduleData);
    const moduleIds = response?.data?.data?.moduleData?.map((d) => d.id);
    setModuleIds(moduleIds);
    // console.log("resp--->", response);
  };

  const onPassword = (e) => {
    setPassword(e.target.value);
  };

  const onConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };
  const onName = (e) => {
    setName(e.target.value);
    setAllData({ ...allData, name: e.target.value });
  };
  const onShortName = (e) => {
    setShortName(e.target.value);
    setAllData({ ...allData, shortName: e.target.value });
  };

  const onEmail = (e) => {
    setEmail(e.target.value);
  };

  const onOverView = (e) => {
    setOverView(e.target.value);
    setAllData({ ...allData, overview: e.target.value });
  };

  const onModule = (moduleId) => {
    setMyArrayModule([]);
    moduleId?.map((d) => {
      if (myArrayModule.includes(d?.value)) {
        setMyArrayModule(myArrayModule);
      } else {
        myArrayModule.push(d?.value);
        setMyArrayModule(myArrayModule);
      }
    });
    setModuleById(moduleId);
    const ids = moduleId.map((d) => d?.value);
    setModuleIds(ids);
  };
  // console.log("modulesss", moduleIds);

  const getDepartmentList = async (id) => {
    const data = {
      businessUnitId: id,
    };
    const response = await instance.post(
      `/customer/department/list-department-business-id`,
      data
    );
    setAllDepartmentList(response?.data?.data?.departmentList);
    // console.log("resp----->", response);
  };

  const onBusiness = (business) => {
    setMyArrayBusiness([]);
    business?.map((d) => {
      if (myArrayBusiness.includes(d?.value)) {
        setMyArrayBusiness(myArrayDepartment);
      } else {
        myArrayDepartment.push(d?.value);
        setMyArrayBusiness(myArrayDepartment);
      }
    });
    const ids = business?.map((d) => d.value);
    getDepartmentList(ids);
    setBusiness(business);
  };
  const onDepartment = (department) => {
    setMyArrayDepartment([]);
    department?.map((d) => {
      if (myArrayDepartment.includes(d?.departmentId)) {
        setMyArrayDepartment(myArrayDepartment);
      } else {
        myArrayDepartment.push(d?.departmentId);
        setMyArrayDepartment(myArrayDepartment);
      }
    });
    setDepartment(department);
  };

  const getModule = async (id) => {
    const response = await instance.get(
      `/customer/employee/list-module-by-role/${id}`
    );
    setModuleDropDownData(response?.data?.data?.moduleData);
    const moduleIdsss = response?.data?.data?.moduleData?.map(
      (d) => d.moduleId
    );
    // console.log("moduleIdsss", moduleIdsss);
    setModuleIds(moduleIdsss);
  };

  const onRole = (e) => {
    setSelectedValues(e.target.value);
    getModule(e.target.value);
  };

  const onFile = (event) => {
    if (event["target"].files.length > 0) {
      const file = event["target"].files[0];
      // setUserData({...userData, profileImage : file});
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0],
      });
      setGetImage(file);
      setGetImageresult(file.name);
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file);
      //     reader.onload = (event) => {
      //         setGetImageresult(reader.result);
      //   };
    }
  };

  //MODULE LIST
  useEffect(() => {
    getModuleDataList();
  }, []);

  async function getModuleDataList() {
    setIsLoading(true);
    getAllModulelist().then(function (result) {
      const response = result?.data;
      setModule(response?.data?.moduleData);
      setIsLoading(false);
    });
  }

  let moduleDropdown = <option>Loading...</option>;
  if (module && module.length > 0) {
    moduleDropdown = module?.map((moduleRow, index) => (
      <option value={moduleRow?.id}>{moduleRow?.type}</option>
    ));
  }

  //department list

  useEffect(() => {
    // getDepartmentDataList();
    getBussinessUnit();
  }, []);

  async function getBussinessUnit() {
    setIsLoading(true);
    getAllIndustryDetailslist(search).then(function (result) {
      const response = result.data;
      // console.log("response+++++++", response);
      setAllBusinessUnit(response?.data);
      setIsLoading(false);
    });
  }

  async function getDepartmentDataList() {
    setIsLoading(true);
    getAllDepartmentDetailslist(search).then(function (result) {
      const response = result.data;
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  }

  //ROLE LIST
  useEffect(() => {
    getRoleDataList();
  }, []);

  async function getRoleDataList() {
    setIsLoading(true);
    getAllRolelist().then(function (result) {
      const response = result.data;
      setAllRoleList(response?.data?.jobRoleList);
      setIsLoading(false);
    });
  }

  let roleDropdown = <option>Loading...</option>;
  if (roleList && roleList.length > 0) {
    roleDropdown = roleList.map((roleRow, index) => (
      <option value={roleRow?.id}>{roleRow?.name}</option>
    ));
  }

  const moduleDrop = module?.map((moduleRow, index) => ({
    value: moduleRow?.id,
    label: moduleRow?.type,
  }));

  const businessUnitDropdown = businesUnitData?.map((deptRow) => ({
    value: deptRow?.id,
    label: deptRow?.name,
  }));
  const departmentDrop = useCallback(
    departmentList?.map((deptRow) => ({
      value: deptRow.id,
      businessUnitId: deptRow.BusinessUnitId,
      label: deptRow.name,
    })),
    [departmentList]
  );

  const onSave = () => {
    let formData = new FormData();

    // console.log(myArrayDepartment, deptfinal, "myArrayModule")

    const businessData = department?.map((d) => ({
      departmentId: d?.value,
      businessUnitId: d?.businessUnitId,
    }));
    const supplierIds = selectedOptions?.map((d) => ({ supplierId: d?.value }));

    formData.append("userId", industryById.get(`id`));
    formData.append(
      "profilePic",
      getImage !== null ? getImage : allData?.profilePic
    );
    formData.append("name", allData?.name);
    formData.append("shortName", allData?.shortName);
    formData.append("overview", allData?.overview);
    formData.append("phone", phone ? phone : allData?.phone);
    formData.append("email", allData?.email);
    formData.append(
      "userJobRoleId",
      selectedValues ? selectedValues : allData?.UserJobRole?.id
    );
    formData.append("businessData", JSON.stringify(businessData));
    formData.append("moduleIds", [moduleIds]);
    formData.append("accountKey", accountKey);
    formData.append("supplierIds", JSON.stringify(supplierIds));
    setIsLoading(true);
    getEditUser(formData, (r) => {
      // console.log(r, "response");
      if (r.success === true) {
        setIsLoading(false);
        toast.success(r.message);
        navigate("/user");
      } else {
        setIsLoading(false);
        // console.log("nononononono");
        toast.error(r.message);
      }
    });
  };
  const onSuppliers = (e) => {
    setSelectedOptions(e);
  };

  // console.log("selectedOptions", selectedOptions);

  return (
    <div className="container-fluid">
      <div className="dbMain users">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/user"
            title={`${t("configuration")} > ${t("user")} > ${t("edit_users")}`}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase">
            <form>
              <div className="browseimg">
                <div className="upld">
                  <label htmlFor="upload-button" className="uploadBtn">
                    {image.preview || allData?.profilePic ? (
                      <img
                        src={
                          image.preview ? image.preview : allData?.profilePic
                        }
                        alt="dummy"
                        width="300"
                        height="300"
                      />
                    ) : (
                      <span className="fa-stack fa-2x">
                        <i className="fa-solid fa-plus"></i>
                      </span>
                    )}
                    <span className="addbtn">
                      <i className="fa-solid fa-circle-plus"></i>
                    </span>
                  </label>
                  <input
                    type="file"
                    id="upload-button"
                    style={{ display: "none" }}
                    onChange={onFile}
                  />
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="name">{t("name")}</label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder={t("placeholder_name")}
                    name="name"
                    value={allData?.name}
                    onChange={onName}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="shortname">{t("short_name")}</label>
                  <input
                    type="text"
                    id="shortname"
                    className="form-control"
                    placeholder={t("placeholder_short_name")}
                    name="shortname"
                    value={allData?.shortName}
                    onChange={onShortName}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="email">{t("email")}</label>
                  <div className="checkmail">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder={t("placeholder_email")}
                      name="email"
                      value={allData?.email}
                      onChange={onEmail}
                    />
                    <i className="fa-solid fa-circle-check"></i>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone">{t("phone")}</label>
                  <PhoneInput
                    defaultCountry="ua"
                    value={allData?.phone}
                    className="phInp"
                    name="phone"
                    onChange={(phone) => setPhone(phone)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="department">{t("business_unit")}</label>
                  <Select
                    isMulti
                    options={businessUnitDropdown}
                    value={business}
                    onChange={onBusiness}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="department">{t("department")}</label>
                  <Select
                    isMulti
                    options={departmentDrop}
                    value={department}
                    onChange={onDepartment}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="role">{t("role")}</label>
                  <select className="form-control" id="role" onChange={onRole}>
                    <option selected hidden>
                      {role ? role : allData?.UserJobRole?.name}
                    </option>
                    {roleDropdown}
                  </select>
                </div>
                {Number(selectedValues) === 27 ? (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="module">{t("module")}</label>
                    <Select
                      isMulti
                      options={moduleDrop}
                      value={moduleById}
                      onChange={onModule}
                    />
                  </div>
                ) : (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="module">{t("module")}</label>
                    <div
                      style={{
                        border: "1px solid #d5cfcf",
                        padding: "10px",
                        borderRadius: "5px",
                        minHeight: "43px",
                      }}
                    >
                      {moduleDropDownData?.map((data, i) =>
                        i === moduleDropDownData?.length - 1 ? (
                          <span>{` ${data?.modulename} `}</span>
                        ) : (
                          <span>{` ${data?.modulename} ,`}</span>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="GLorAccountingkey">
                    {t("accounting_key")}
                  </label>
                  <input
                    type="text"
                    id="GLorAccountingkey"
                    className="form-control"
                    placeholder={t("placeholder_accounting_key")}
                    name="accountKey"
                    value={accountKey}
                    onChange={(e) => setAccountKey(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="overview">{t("overview")}</label>
                  <textarea
                    className="form-control"
                    placeholder={t("placeholder_overview")}
                    onChange={onOverView}
                    id="overview"
                    name="overview"
                    value={allData?.overview}
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Supplier">{t("suppliers")}</label>
                  <Select
                    id="Supplier"
                    placeholder={t("select_supplier")}
                    isMulti
                    options={invoiceSupplierDataList?.map((item) => ({
                      label: item?.name,
                      value: item?.id,
                    }))}
                    value={selectedOptions}
                    onChange={onSuppliers}
                  />
                </div>
              </div>

              <button type="button" className="commonButton" onClick={onSave}>
                <Link>{t("save")}</Link>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
